import signInReducer from "../context/auth/signIn/reducer";
import signOutReducer from "../context/auth/signOut/reducer";
import authReducer from "../context/auth/auth/reducer";
import standsReducer from "../context/stands/reducer";
import breadcrumbsReducer from "../context/breadcrumbs/reducer";
import sponsorsReducer from "../context/sponsors/reducer";
import * as Sentry from "@sentry/react";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { applyMiddleware, combineReducers, compose, createStore, Store } from "redux";
import thunk from "redux-thunk";

let store: Store;

const rootReducer = combineReducers({
  authReducer,
  signInReducer,
  signOutReducer,
  standsReducer,
  breadcrumbsReducer,
  sponsorsReducer,
});

const persistConfig = {
  key: "root",
  storage,
  timeout: 0,
  whitelist: ["authReducer", "userDetailReducer"],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);
const middlewares = [thunk];

if (process.env.NODE_ENV === "development") {
  store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(...middlewares)));
} else {
  const sentryReduxEnhancer = Sentry.createReduxEnhancer();
  store = createStore(persistedReducer, compose(applyMiddleware(...middlewares), sentryReduxEnhancer));
}

const persistor = persistStore(store);
export { store, persistor };
